import setpAlertNextSetp from '../../components/alert-next-step'

export default {
  setpAlertNextSetp
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/create/resources/components.js